import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import { Card, CardContent, CardHeader, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export default function ApprovedSend(props) {

    const { t } = useTranslation()
    const {dataSummary, datasPlanning,checkAdd,dataPA} = props;
    const [summary, setSummary] = React.useState([]);
    const [typeList, setTypeList] = React.useState([]);
    const [scores, setScore] = React.useState(0);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    useEffect(() => {
        mappingSum()
        mapping()
    }, [dataSummary, datasPlanning,]);
    useEffect(() => {
        mappingSum()
    }, [checkAdd]);
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
          return data;
        }
        return defaults;
    }
    let sumScore = (data) => {
        let totals = 0
        data.rb_condition.map((data) => { totals = totals + calculateScore(data) })
        return totals
    }
    let calculateScore = (data) => {
        let sum = eval(data.calculate_score)
        let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
        return scores
    }
    let calculateSum = (datas) => {
        let data = summary
        let summarys = eval(datas.sum)
        summarys = Number.isNaN(Number(summarys)) ? 0 : Math.round(summarys * 100) / 100
        return summarys.toFixed(2)
    }
    let sumScoreAccumulateUse = (data) => {
        let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
        for (let index = 0; index <= data.rb_condition.length - 1; index++) {
            totals = totals + Number(calculateScore(data.rb_condition[index]))
        }
        return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    }
    let totalScore = () => {
        let totals = 0
        if(typeList.length > 0) {
            typeList.map((data) => { 
                // console.log(data,74);
                totals = totals + data.score 
            })
        }
        return totals
    }
    const mappingSum = () => {
        if (datasPlanning !== undefined && datasPlanning !== null && datasPlanning !== "null") {
            var data = {}
            for (let index = 0; index <= datasPlanning.length - 1; index++) {
                for (let indexs = 0; indexs <= dataSummary.length - 1; indexs++) { 
                    data[datasPlanning[index].code]=Number(sumScoreAccumulateUse(datasPlanning[index]));
                }
            }
            setSummary(data);
        }
    }
    const mapping = () => {
        if (datasPlanning !== undefined && datasPlanning !== null && datasPlanning !== "null") {
            var typeData = []
            var Data = []
            var score = 0
            for (let index1 = 0; index1 <= datasPlanning.length - 1; index1++) {
                for (let indexs2 = 0; indexs2 <= dataPA.ratio_data.length - 1; indexs2++) {
                    if (dataPA.ratio_data.length > 0 ) {
                        if (datasPlanning[index1].serial === Object.keys(dataPA.ratio_data[indexs2])[0]) {
                            typeData.push({type: datasPlanning[index1],score: Number(sumScoreAccumulateUse(datasPlanning[index1]))})
                            setCriterionScore(dataPA.ratio_data[indexs2][Object.keys(dataPA.ratio_data[indexs2])].criterion_score);
                            Data = typeData
                        }
                    }
                }
            }
            setTypeList(Data)
            setScore(score)
        }
    }

    return (
        <Grid container item>
            <Grid container spacing={4}>
                <Grid item lg={6} xs={6}>
                    <Card sx={{ height: 1 ,borderRadius: "10px"}}>
                        <CardHeader variant="summary"
                            title={t('planning.label.overviewScore')}
                            sx={{borderRadius: "0px"}}
                        />
                        <CardContent>
                            <TableContainer>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('planning.label.evalType')}</Typography></TableCell>
                                            <TableCell align="center"><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('label.score')}</Typography></TableCell>
                                        </TableRow>

                                    </TableHead>

                                    <TableBody>
                                    {typeList !== undefined && typeList !== null && typeList.length > 0 ?
                                        typeList.map(item => (
                                        <TableRow>
                                            <TableCell component="th" scope="row" fontSize={18} lineHeight="24.59px" sx={{paddingBottom: "3px" , "border": "none"}}>
                                                {item.type.description}
                                            </TableCell>
                                            <TableCell align="center" component="th" scope="row" fontSize={18} lineHeight="24.59px" sx={{paddingBottom: "3px" , "border": "none"}}>
                                                {item.score.toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                        )) : null
                                    }
                                    {/* <Grid sx={{paddingTop: "20px"}}>
                                        <Divider  />
                                    </Grid> */}
                                        <TableRow>
                                            <TableCell component="th" scope="row" align="right" sx={{paddingBottom: "3px" , "border": "none"}}>
                                                <Typography fontWeight={500} fontSize={18} lineHeight="24.59px">{t('label.scoreTotal')}</Typography>
                                                <Typography variant="label_sub1" fontSize={14} fontWeight={300} lineHeight="19.12px" color="#AAAAAA">(ภาระงานขั้นต่ำ {criterionScore} คะแนน)</Typography>
                                            </TableCell>
                                            <TableCell align="center" component="th" scope="row" sx={{ "vertical-align": "baseline",paddingBottom: "3px" , "border": "none" }}>
                                                <Typography fontWeight={500} fontSize={18} lineHeight="24.59px" color={cssVariables.color.primary}>{totalScore().toFixed(2)}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={6} xs={6}>
                    <Card sx={{ height: 1 ,borderRadius: "10px"}}>
                        <CardHeader variant="summary"
                            title={t('planning.label.ruleAndCondition')}
                            sx={{borderRadius: "0px"}}
                        />
                        <CardContent>
                            <TableContainer>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow sx={{borderBottom: "0.5px solid #E4E4E4"}}>
                                            <TableCell><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('planning.label.ruleAndCondition')}</Typography></TableCell>
                                            <TableCell sx={{textAlign: "center",whiteSpace: "nowrap"}}><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('planning.label.low')}</Typography></TableCell>
                                            <TableCell sx={{textAlign: "center",whiteSpace: "nowrap"}}><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('planning.label.high')}</Typography></TableCell>
                                            <TableCell sx={{textAlign: "center",whiteSpace: "nowrap"}}><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('planning.label.portion')}</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {dataSummary !== undefined && dataSummary !== null && dataSummary.length > 0 ?
                                        dataSummary.map(item => (
                                        <TableRow>
                                            <TableCell component="th" scope="row" sx={{paddingBottom: "3px" , "border": "none"}}>
                                                <Typography fontSize={16} lineHeight="21.86px">{formatData(item?.description, "-")}</Typography>
                                            </TableCell>
                                            <TableCell component="th" scope="row" sx={{paddingBottom: "3px",textAlign: "center" , "border": "none"}}>
                                                <Typography fontSize={16} lineHeight="21.86px">{formatData(item?.min !== 0 ? item?.min : "-", "-")}</Typography>
                                            </TableCell>
                                            <TableCell component="th" scope="row" sx={{paddingBottom: "3px",textAlign: "center" , "border": "none"}}>
                                                <Typography fontSize={16} lineHeight="21.86px">{formatData(item?.max !== 0 ? item?.max : "-", "-")}</Typography>
                                            </TableCell>
                                            <TableCell component="th" scope="row" sx={{paddingBottom: "3px",textAlign: "center" , "border": "none"}}>
                                                {item?.action === "error" ?
                                                    <Typography color= {calculateSum(item) >= item?.min ? item?.max > 0 ? calculateSum(item) <= item?.max ? "#5DA196" : "#CC6058" : "#5DA196" : "#CC6058"} fontSize={16} lineHeight="21.86px">
                                                        {calculateSum(item) !== undefined && calculateSum(item) !== null && calculateSum(item) !== NaN ? calculateSum(item) : 0 }
                                                    </Typography>
                                                    :
                                                    <Typography color= {calculateSum(item) >= item?.min ? item?.max > 0 ? calculateSum(item) <= item?.max ? "#5DA196" : "#CC6058" : "#5DA196" : "#FFBF49"} fontSize={16} lineHeight="21.86px">
                                                        {calculateSum(item) !== undefined && calculateSum(item) !== null && calculateSum(item) !== NaN ? calculateSum(item) : 0 }
                                                    </Typography>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        )) : null
                                    }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Grid>
    );
}